<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        <h2 >स्मार्ट कलेक्ट के मामलों का उपयोग करें </h2>
                    </h2>
                </div>

                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='61'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/t4vkDWertB0?si=NX2r1nkNpN65kn0U" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id='62'>
                   
                    <h4 >
                        स्मार्ट कलेक्ट के मामलों का उपयोग करें
                    </h4>

                   

                    
                    <label for="" class="mt-3" ><b>स्कूल शुल्क संग्रहण:</b>&nbsp;
                        शैक्षणिक संस्थानों में छात्रों और अभिभावकों से ट्यूशन और फीस एकत्र करने की
                        प्रक्रिया को सरल बनाएं। एक कुशल स्कूल शुल्क संग्रहण प्रणाली लागू करें जो
                        ऑनलाइन भुगतान की अनुमति देती है, विस्तृत चालान प्रदान करती है और पारदर्शी
                        रिकॉर्ड-रख-रखाव सुनिश्चित करती है। यह प्रशासनिक कार्यों को सुव्यवस्थित करने
                        में मदद करता है और समय पर भुगतान सुनिश्चित करता है, जिससे स्कूल के वित्तीय
                        संचालन के सुचारू संचालन में योगदान मिलता है। </label>

                    <label for="" class="mt-4" ><b> कॉलेज शुल्क संग्रहण: &nbsp;
                        </b>छात्रों के लिए कॉलेज ट्यूशन फीस और संबंधित शुल्कों के संग्रह को
                        सुव्यवस्थित करें। एक मजबूत कॉलेज शुल्क संग्रह प्रणाली ऑनलाइन भुगतान की
                        सुविधा देती है, अनुकूलित शुल्क संरचनाओं के निर्माण की अनुमति देती है, और
                        विस्तृत वित्तीय विवरण प्रदान करती है। यह सुनिश्चित करता है कि छात्र और उनके
                        परिवार शैक्षिक खर्चों का आसानी से प्रबंधन कर सकें, जबकि कॉलेज सटीक वित्तीय
                        रिकॉर्ड बनाए रखते हैं। </label>
                    <label for="" class="mt-4" ><b>सरकार. बिल (बिजली बिल):&nbsp;</b>
                        इसमें ग्राहकों को बिजली बिल बनाना और वितरित करना, ऑनलाइन भुगतान जैसे कई
                        भुगतान विकल्प प्रदान करना और ग्राहकों को उनके बिजली के उपयोग को ट्रैक और
                        प्रबंधित करने के लिए एक उपयोगकर्ता-अनुकूल इंटरफ़ेस प्रदान करना शामिल है। एक
                        प्रभावी बिजली बिलिंग प्रणाली सटीक बिलिंग, समय पर भुगतान और बेहतर ग्राहक
                        संतुष्टि में योगदान करती है। </label>

                    <label for="" class="mt-4" ><b>सरकार. बिल (पानी के बिल):
                            &nbsp;</b>ग्राहकों को उनके पानी के उपयोग और बिलों का स्पष्ट विवरण प्रदान
                        करने से जल संरक्षण को बढ़ावा देने में मदद मिलती है और एक पारदर्शी और कुशल
                        बिलिंग प्रक्रिया सुनिश्चित होती है।

                    </label>
                </div>

                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id='63'>
                 
                    <h2 >इन सात चरणों के साथ जल्दी और आसानी से एक स्मार्ट कलेक्ट
                        प्रोफ़ाइल बनाएं:
                    </h2>


                    
                    <label for="" class="mt-5" ><b> चरण 1:&nbsp;</b> PayG खाते के लिए
                        साइन अप करें। यदि आपके पास पहले से ही एक खाता है, तो अपने क्रेडेंशियल्स के
                        साथ लॉग इन करें। </label>
                    <label for="" class="mt-4" ><b> चरण 2: &nbsp;</b>पे प्रोफाइल अनुभाग
                        पर जाएं और एक नई प्रोफ़ाइल बनाएं।   </label><br>
                    <label for="" class="mt-4" ><b> चरण 3: &nbsp;</b> व्यवसाय विवरण
                        भरें।  
                    </label><br>
                    <label for="" class="mt-4" ><b> चरण 4: &nbsp;</b>अपने ग्राहकों के
                        लिए फ़ील्ड बनाएं और फिर उनमें डेटा जोड़ें।

                    </label><br>
                    <label for="" class="mt-4" ><b> चरण 5: &nbsp;</b> भुगतान रसीद
                        सेटिंग्स कॉन्फ़िगर करें।     </label><br>
                    <label for="" class="mt-4" ><b> चरण 6: &nbsp;</b>वेतन प्रोफ़ाइल
                        कॉन्फ़िगरेशन समायोजित करें।     </label><br>
                    <label for="" class="mt-4" ><b> चरण 7 : &nbsp;</b>अपनी प्रोफ़ाइल
                        अपने ग्राहकों के साथ साझा करें और भुगतान स्वीकार करना शुरू करें।    </label>


                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id='63'>
                    
                    <label for="" class="mt-3" >
                        अपने अकाउंट में साइन इन करें
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/booking1.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                   
                    <label for="" class="mt-3" >
                        डैशबोर्ड पर पे प्रोफ़ाइल अनुभाग पर जाएँ।
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/A screenshot1.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                   
                    <label for="" class="mt-3" >
                        "Create New Pay Profile" पर क्लिक करें
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                  
                    <label for="" class="mt-3" >
                        “Smart Collect” चुनें।
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/A screenshot2.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                   
                    <label for="" class="mt-3" >
                        अपनी आवश्यकताओं के अनुसार एक टेम्पलेट चुनें.
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/A screenshot3.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                 
                    <label for="" class="mt-3" >
                        अपनी ब्रांडिंग के अनुरूप रंग थीम चुनें। अपने भुगतान संग्रह के लिए एक शीर्षक
                        प्रदान करें और अपने संगठन के बारे में संपर्क विवरण के साथ एक विवरण भी शामिल
                        करें।
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (1).png" width="60%" alt="">
                        </div>
                    </div>

                  
                    <label for="" class="mt-3" >
                        ग्राहकों के लिए निर्दिष्ट अद्वितीय फ़ील्ड का उपयोग करके अपना विवरण दर्ज करने
                        और खोजने के लिए इनपुट फ़ील्ड बनाएं। इसके अतिरिक्त, प्रासंगिक जानकारी के लिए
                        आउटपुट फ़ील्ड शामिल करें।
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (2).png" width="60%" alt="">
                        </div>
                    </div>
                   
                    <label for="" class="mt-3" >


                        यह निर्दिष्ट करने के लिए कि आप अपने ग्राहकों से भुगतान कैसे एकत्र करना चाहते
                        हैं, एक राशि फ़ील्ड जोड़ें। और यदि आप डेटा में सुरक्षा जोड़ना चाहते हैं, तो
                        आप उस फ़ाइल में अपने ग्राहक का मोबाइल नंबर जोड़ सकते हैं।
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (3).png" width="60%" alt="">
                        </div>
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (4).png" width="60%" alt="">
                        </div>
                    </div>
                   
                    <label for="" class="mt-3" >


                        पिछले चरण में आपके द्वारा बनाए गए फ़ील्ड में डेटा जोड़ें। आप एक-एक करके
                        मैन्युअल रूप से डेटा जोड़ सकते हैं या अपने सभी ग्राहकों का संपूर्ण डेटा
                        जोड़ने के लिए एक सीएसवी फ़ाइल अपलोड कर सकते हैं।
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (5).png" width="60%" alt="">
                        </div>
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (6).png" width="60%" alt="">
                        </div>
                    </div>
                    
                    <label for="" class="mt-3" >



                        अगला चरण “Payment Receipt Settings” है। अपनी आवश्यकता के अनुसार चयन करें और
                        अगले चरण पर जाएँ।  
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (7).png" width="100%" alt="">
                        </div>
                    </div>
                    
                    <label for="" class="mt-3" >


                        "Pay Profile Settings" अनुभाग में, आपके पास एक कस्टम यूआरएल सेट करने के
                        विकल्प हैं। आप यूआरएल को वैयक्तिकृत कर सकते हैं या "Create a random URL" का
                        चयन करके यादृच्छिक रूप से जेनरेट किए गए यूआरएल का विकल्प चुन सकते हैं। इसके
                        अतिरिक्त, आप अपने ग्राहकों के लिए आंशिक भुगतान सक्षम कर सकते हैं। आपकी
                        प्रोफ़ाइल कब सक्रिय होनी चाहिए इसके लिए दिनांक और समय निर्धारित करें। आपके
                        पास अपनी प्रोफ़ाइल के लिए एक बटन और एक क्यूआर कोड शामिल करने का विकल्प है।
                        अपनी प्राथमिकताएँ चुनें और फिर अपनी प्रोफ़ाइल बनाने के लिए "Next" बटन पर
                        क्लिक करें।    
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (8).png" width="100%" alt="">
                        </div>
                    </div>


                   
                    <label for="" class="mt-3" >
                        आप लिंक को कॉपी कर सकते हैं और अपने ग्राहकों को भेजने के लिए क्यूआर कोड
                        डाउनलोड कर सकते हैं। इसके अतिरिक्त, आप इसे अपने ग्राहकों के साथ उनके मोबाइल
                        नंबर या ईमेल पर साझा कर सकते हैं
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (9).png" width="60%" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                   >
                    <h5 >
                        विषयसूची :
                    </h5>
                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#61">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                   
How to Use Cases 
</span>
                            </div>
                        </div>
                    </a> -->
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#62">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >

                                    स्मार्ट कलेक्ट के मामलों का उपयोग करें
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#63">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    >

                                    स्मार्ट कलेक्ट पे प्रोफाइल कैसे बनाएं?
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/Hindi Pay Profile(Smart Collect) 1.pdf"
                                target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    स्मार्ट कलेक्ट </span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/Hindi Pay Profile(Smart Collect) 1.pdf" download><img src="./assets/Download.svg"
                                    alt="" width="100%"></a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
              
                <a [routerLink]="['/easy-collect']">    <button class="btn btn-color" (click)="menues('Easy Collect')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;ईजी कलेक्ट

                </button></a>
            </div>
            <div class="col-md-4    ">
               
                <a [routerLink]="['/booking-tecketing']">  <button class="btn btn-color" (click)="menues('Booking & Ticketing')"
                    >बुकिंग और
                    टिकटिंग

                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>

        </div>
    </div>
    </div>